import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { authUtils } from '@/lib/api/auth'
import { toast } from 'sonner'

/**
 * Hook to handle session expiration
 * Listens for 401 responses and handles logout
 */
export function useSessionExpiration() {
  const navigate = useNavigate()

  const handleLogout = useCallback(() => {
    console.error('[Session] auth:unauthorized received — logging out and redirecting to /auth')
    authUtils.removeToken()
    toast.error('Session expired. Please login again.')
    navigate('/auth', { replace: true })
  }, [navigate])

  useEffect(() => {
    // Listen for 401 responses from axios interceptor
    const handleUnauthorized = (event: Event) => {
      if (event instanceof CustomEvent && event.detail?.status === 401) {
        handleLogout()
      }
    }

    window.addEventListener('auth:unauthorized', handleUnauthorized as EventListener)

    return () => {
      window.removeEventListener('auth:unauthorized', handleUnauthorized as EventListener)
    }
  }, [handleLogout])
}
